<template>
    <div :style="style">
        <v-chart :options="bar" />
    </div>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line"; //折线图
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";

    export default {
        name:'ELine',
        props:[
            'size',
            'xAxis',
            'series',
        ],
        components:{
            "v-chart":ECharts,
        },
        computed:{
            bar(){
                this.option.xAxis.data = this.xAxis
                this.option.series[0].data = this.series.data;
                this.option.series[0].name = this.series.name;
                return this.option;
            },
            style(){
                return this.size ? this.size : this.echartStyle;
            }
        },
        data(){
            const clientWidth = document.body.clientWidth;
            return{
                option:{
                        color: ["#3398DB"],
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "line" // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        grid: {
                            top: "12%",
                            left: "3%",
                            right: "4%",
                            bottom: "3%",
                            containLabel: true
                        },
                        xAxis: {
                            type: "category",
                            // boundaryGap: false,
                            axisTick: {
                            alignWithLabel: true
                            },
                            data: [],
                            axisLabel: {
                            margin: 20,
                            textStyle: {
                                color: "#333333"
                            }
                            },
                            axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                            }
                        },
                        yAxis: {
                            type: "value",
                            axisLine: {
                            //隐藏y轴线
                            show: false
                            },
                            axisTick: {
                            //隐藏y轴刻度线
                            show: false
                            },
                            splitLine: {
                            //分隔线
                            lineStyle: {
                                type: "dashed" //分隔线---虚线
                            }
                            }
                        },
                        series: [
                            {
                            name: "",
                            data: [],
                            type: "line",
                            lineStyle: {
                                width: 4 //折线宽度
                            }
                            }
                        ],
                        dataZoom: {
                            type: "inside",
                            xAxisIndex: [0],
                            start: 0,
                            end: 100
                        }
                },
                echartStyle: {
                    width: ((clientWidth - 300) / 3) * 2 + "px",
                    height: (clientWidth - 300) / 4 + "px"
                },
            }
        }
    }
</script>
<style  scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
